
export enum PatientEditMode {
  DEFAULT,
  VACCINATION
}
